import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {formatDate} from '@angular/common';


@Pipe({
    name: 'datePrefix',
    standalone: true
})
export class DatePrefixPipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {
  }

  transform(value: Date | null | undefined): string {
    if (value !== undefined && value !== null) {
      const dateToday = formatDate(new Date(), 'yyyy-MM-dd', 'en_US');
      const dateGiven = formatDate(value, 'yyyy-MM-dd', 'en_US');

      if (dateGiven > dateToday) {
        return this.translate.instant('delivery-date-pipe.future');
      } else if (dateGiven < dateToday) {
        return this.translate.instant('delivery-date-pipe.past');
      } else {
        return this.translate.instant('delivery-date-pipe.today');
      }
    }
    return '';
  }

}
